import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { CampaignService } from '@app/_core/services/campaign.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss'],
})
export class CampaignsComponent implements OnInit {
  constructor(
    private utils: Utils,
    private appService: AppService,
    private campaignService: CampaignService,
    private webStorage: WebStorageService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  showTable: boolean = true;
  showCrud: boolean = false;
  showDateRange: boolean = false;
  modalRef?: BsModalRef;
  campaignList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];
  localStorageName = 'CampaignsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    { label: 'Name', value: 'Name' },
    { label: 'Campaign ID', value: 'ID' },
    { label: 'CRM Campaign ID', value: 'CrmCampaignID' },
  ];
  selectedFilterByField: any = '';
  filterVal: any = '';

  cols: any = [
    { name: 'ID', label: 'ID', showFilter: true, minWidth: 5 },
    { name: 'Name', label: 'Name', showFilter: true, minWidth: 5 },
    { name: 'Type', label: 'Type', showFilter: true, minWidth: 5 },
    { name: 'CrmCampaignID', label: 'CRM Campaign ID', minWidth: 5 },
    { name: 'TotalRecords', label: 'Records', minWidth: 5 },
    { name: 'Status', label: 'Status', showFilter: true, minWidth: 5 },
    { name: 'Start', label: 'Start', type: 'date', minWidth: 5 },
    { name: 'End', label: 'End', type: 'date', minWidth: 5 },
    { name: 'LastUpdated', label: 'Last Updated', type: 'date', minWidth: 5 },
  ];

  ngOnInit(): void {
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu?.name;
    });
    this.selectedFilterByField = this.findOptions[0];
    this.loadCampaigns();
    this.initializeColumnHeader();
  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.filterVal = '';
    this.filteredData = this.campaignList;
    this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }
  applyFilterByField(val) {
    this.selectedFilterByField = val.searchField;
    this.filterVal = val.searchValue;
    if (this.selectedFilterByField.value != '' && this.filterVal != '') {
      this.filteredData = this.findByMatchingProperties(this.campaignList, this.selectedFilterByField, this.filterVal);
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    }
  }

  findByMatchingProperties(set: any, properties: any, searchText: string) {
    return set.filter((entry: any) => {
      //alert(typeof(entry[properties.value]))
      if (typeof entry[properties.value] === 'number') {
        if (entry[properties.value].toString() == searchText) {
          return entry;
        }
      } else if (entry[properties.value].toString().includes(searchText)) return entry;
    });
  }

  toggleCustomColumnFilter(colName: string) {
    for (const col of this.cols) {
      if (col.name == colName) {
        if (col.filterVals) {
        } else {
          const unique = [...new Set(this.filteredData.map((item: any) => item[colName]))];
          const filterData: any = [];
          for (const val of unique) {
            filterData.push({ name: val, checked: false });
          }
          col.filterVals = filterData;
        }
      } else {
      }
    }
    this.showColumnFilterModal(colName);
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    });
  }

  /*column level filter*/
  applyColumnFilters(list: any) {
    //apply column filter here and assign to dataTodisplay
    let records = list;
    for (const colData of this.cols) {
      const filterVals: any = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name);
          }
        }
        //filterVals
        records = this.filterBySelectedFieldValues(records, colData.name, filterVals);
      }
    }
    return records;
  }

  filterBySelectedFieldValues(set: any, properties: string, searchText: []) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          if (entry[properties].toString() == search) {
            return entry;
          }
        }
      });
    } else {
      return set;
    }
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };
    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }

  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }

  onRowSelect(event: any) {
    this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }

  loadCampaigns() {
    this.campaignService.GetCampaigns().subscribe((data: any) => {
      const isValid = ResponseHandler.processResponse(data, 'GetCampaigns');
      if (isValid) {
        this.campaignList = data.Response.Data;
        this.filteredData = this.campaignList;
        this.dataToDisplay = this.campaignList;
        this.setInnerWidthHeightParameters();
      } else {
      }
    }),
      catchError(error => {
        return EMPTY;
      });
  }

  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }

  newCampaign() {
    this.router.navigateByUrl(this.router.url + '/New');
  }

  clearFilter() {
    this.cols?.forEach((col: any) => {
      delete col.filterVals;
    });
    this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }
}
